import React from 'react';

import PropTypes from 'prop-types';
import FaThumbsUp from 'react-icons/lib/fa/thumbs-up';

import { localize } from 'wanderu-i18n';

import localesConfig from '../../../config/explorer.locales';

import styles from './CityCard.scss';

function CityCard(props) {
    const {
        cityInfo,
        date,
        i18nMoment,
        i18nMoney,
        isSelected,
        price,
        t,
        toggleTrip,
    } = props;

    const {
        city,
        country,
        state,
        wcityid,
    } = cityInfo.location;
    const { photourl } = cityInfo;

    let backgroundImage;
    if (photourl) {
        backgroundImage = { backgroundImage: `url(${photourl})` };
    }

    let placeName = `${city}, ${country}`;
    if (['US', 'CA'].includes(country)) {
        placeName = `${city}, ${state}`;
    }
    const displayDate = date && i18nMoment(date).format('ddd, MMM D');
    const displayPrice = price && i18nMoney(price).format();

    return (
        <div
            className={styles.container}
            onClick={() => toggleTrip({ date: displayDate, price: displayPrice, wcityid })}
        >
            <div className={`${styles.innerContainer} ${isSelected
                ? styles.selected
                : ''}`}>
                {price <= 5 && (
                    <span className={styles.deal}>
                        <FaThumbsUp className={styles.dealGlyph} />
                        {t('great-deal')}
                    </span>
                )}
                <div className={styles.imgContainer}>
                    <div
                        className={styles.city}
                        style={backgroundImage}
                    />
                </div>
                <div className={styles.date}>
                    {displayDate}
                </div>
                <div className={styles.infoContainer}>
                    <span className={styles.location}>{placeName}</span>
                    <span className={styles.price}>{displayPrice}</span>
                </div>
            </div>
        </div>
    );
}

CityCard.propTypes = {
    cityInfo: PropTypes.shape({
        location: PropTypes.shape({
            city: PropTypes.string,
            country: PropTypes.string,
            state: PropTypes.string,
            wcityid: PropTypes.string,
        }),
        photourl: PropTypes.string,
    }),
    date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    i18nMoment: PropTypes.func,
    i18nMoney: PropTypes.func,
    isSelected: PropTypes.bool,
    price: PropTypes.number,
    t: PropTypes.func,
    toggleTrip: PropTypes.func,
};

export { CityCard };
export default localize(CityCard, localesConfig.namespace);
